
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as AppState from '../../../AppState';
import React from 'react';
import TextInput from './TextInput';
import { toast } from 'react-toastify';
import Checkbox from '../../Shared/Checkbox/Checkbox';
import { useRecoilValue } from 'recoil';
import { createSavedHomeSearch } from '../../../services/saved-home-search/savedHomeSearch';
import { FrequencySelectInput, frequency } from './FrequencySelectInput';

interface SavedHomeSearchProps {
	search: any;
	dispatch: React.Dispatch<any>;
	setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SavedHomeSearchDropdownComponent = ({
	search,
	dispatch,
	setLoading,
}: SavedHomeSearchProps) => {

	const gsFilters = useRecoilValue(AppState.gsFilters);
	const userLocation = useRecoilValue(AppState.gsUserLocation);

	const handleSubmitClick = () => {
		if (search.name === '') {
			return toast.error('Please provide a name for your subscription.',
				{
					icon: <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} />,
					toastId: 'errorSubmittingSavedSearchAlert-name',
					containerId: 'filterWarningToastContainer',
					theme: 'light',
				}
			);
		}

		setLoading(true);
		toast.promise(
			createSavedHomeSearch(search.name, gsFilters, search.frequency.label, userLocation),
			{
				pending: {
					icon: <FontAwesomeIcon icon={['far', 'spinner']} className=' cc-btn__icon cc-btn__icon--prefix spinner' />,
					render: 'Submitting subscription...'
				},
				success: {
					icon: < FontAwesomeIcon icon={['far', 'face-smile-plus']} />,
					render: 'Subscription submitted!'
				},
				error: {
					icon: <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} />,
					render: 'Error submitting subscription.',
				}
			},
			{
				toastId: 'successSubmittingSavedSearchAlert',
				containerId: 'filterWarningToastContainer',
				theme: 'light'
			}
		).then(() => {
			dispatch({ type: 'clearInformation' });
		}
		)
			.catch((err) => console.error(err))
			.finally(() => setLoading(false));

	};

	return <div className='saved-home-search--dropdown'>
		<h2>Save Your Search</h2>
		<p>Save your search and Sign-up to receive email alerts on updates on properties in the search area</p>
		<TextInput
			label='Search Name: '
			className='w-100 form-control'
			id='saved-home-search-client-name-input'
			value={search.name}
			onChange={(value) => dispatch({ type: 'setName', value: value })}
		/>
    <FrequencySelectInput
      id='saved-home-search-client-marketing-opt-in-checkbox'
      label='I wish to receive email updates on this search on the following basis'
      options={[{ label: frequency.Daily, value: 3 }, { label: frequency.Weekly, value: 2 }, { label: frequency.Monthly, value: 1 }, { label: frequency.Never, value: 0 }]}
      option={search.frequency}
      disabled={!search.marketingOptIn}
      invalid={false}
      onSelect={(value) => dispatch({ type: 'setFrequency', value: value })} />
    <Checkbox
      id='saved-home-search-client-marketing-opt-in-checkbox'
      name='marketing-opt-in'
      label='I opt-in to receiving promotional communications from CapCenter including emails, phone calls, and text messages'
      labelClassName='saved-home-search--dropdown-checkbox-label'
      checkedValue={search.marketingOptIn}
      onCheckedChange={(value) => dispatch({ type: 'setOptIn', value: value })}
      defaultChecked={true}
    />
		<button className={'cc-btn cc-btn--lg cc-btn--filled cc-btn--primary cc-btn--reset-text cc-btn--navbar mt-4 mx-0 d-flex w-100 saved-home-search--submit-button ' }
			onClick={() => {
				handleSubmitClick();
			}}
		>
			Save Search
		</button>

	</div>;
};
